exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-frame-product__select-image-title[data-v-25d4ef0c]{font-size:16px;font-weight:700}.option-frame-product__placeholder-image[data-v-25d4ef0c],.option-frame-product__selected-image[data-v-25d4ef0c]{border:1px solid #ccc;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25d4ef0c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/shared/components/catalog/PackageOption/PackageOptionFrameProduct.vue
// module id = 794
// module chunks = 0 2